import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  Machine,
  MachineDetailComponent,
  MachineFormComponent,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-machine-overview',
  templateUrl: './machine-overview.component.html',
  styleUrls: ['./machine-overview.component.scss'],
  standalone: false,
})
export class MachineOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalCtrl: ModalController,
    public toolService: ToolService
  ) {}

  allEntries: Machine[] = [];
  filteredEntries: Machine[] = [];
  searchTerm: string = '';
  sub: Subscription;

  ngOnInit() {
    this.sub = this.state.machines$.subscribe((x) => {
      this.allEntries = x;
      this.filterEntries();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  filterEntries() {
    if (this.searchTerm != '' || this.searchTerm != null) {
      this.filteredEntries = this.allEntries.filter(
        (x) =>
          x.inventoryNumber.toLocaleLowerCase().includes(this.searchTerm) ||
          x.manufacturer.toLocaleLowerCase().includes(this.searchTerm) ||
          x.type.toLocaleLowerCase().includes(this.searchTerm)
      );
    } else {
      this.filteredEntries = this.allEntries;
    }
  }

  handleSearchInput(event: any) {
    let term = event.target.value as string;
    this.searchTerm = term.trim().toLocaleLowerCase();
    this.filterEntries();
  }

  async openDetailModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: MachineDetailComponent,
      componentProps: {
        paramId: id,
      },
      cssClass: this.state.isBigScreen ? 'height-desktop-modal' : '',
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm') {
      if (data == 'edit') {
        this.openFormModal(id);
      }
    }
  }

  async openFormModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: MachineFormComponent,
      componentProps: {
        paramId: id,
      },
      cssClass: this.state.isBigScreen ? 'height-desktop-modal' : '',
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && id != null) {
      this.openDetailModal(id);
    }
  }
}
